export default __webpack_public_path__ + "static/media/Group 891.2a2d74ee.svg";